import BriefContactFilterV2, {
  BriefContactFilterV2Props,
} from "./BriefContactFilterV2";

export default function BriefContactFilter(props: BriefContactFilterV2Props) {
  return <BriefContactFilterV2 {...props} />;
}
